<div class="full-size-loader">
  <div class="loading-animation"></div>
</div>
<app-modal-confirm
    [attr.data-test]="'modal-combinationNotAvailable'"
    [type]="iconType.WARNING"
    modalTitle="{{ 'external-redirect.combination-not-available.title' | translate }}"
    notifyText="{{ 'external-redirect.combination-not-available.text' | translate }}"
    primaryBtnText="{{ 'external-redirect.combination-not-available.primary-btn' | translate }}"
    secondaryBtnText="{{ 'external-redirect.combination-not-available.secondary-btn' | translate }}"
    [showModalConfirm]="isErrorModalVisible"
    (primaryActionConfirm)="redirectTo(isBusinessPartner ? EFeatureRoutes.EQUIPMENT_SELECTION : EFeatureRoutes.MY_INSTALLED_BASE, true)"
    (secondaryActionConfirm)="redirectTo(EFeatureRoutes.CATALOG)">
</app-modal-confirm>
<app-modal-select-sold-to-account
    [attr.data-test]="'modal-soldToSelection'"
    [showModalConfirm]="isSoldToSelectionModalVisible"
    [soldToAccounts]="soldToAddresses"
    [isLoadingSoldToAddresses]="!areSoldToAddressesLoaded"
    (closeModalConfirm)="isSoldToSelectionModalVisible = false"
    (primaryActionConfirm)="selectSoldToAddress($event)">
</app-modal-select-sold-to-account>
